// extracted by mini-css-extract-plugin
export default {"tooltip":"tooltip--WFcnE","ellipsis":"ellipsis--fWlJW","icon":"icon--Ksx6X","target":"target--oIEez","valueItem":"valueItem--Qy2qG"};